import { FindStoreComponentData, storeFinder } from "@/common/lib/types";
import Button from "@/components/ui/button/Button";
import { notFound } from "@/constants/icons";
import { cn } from "@/lib/tailwind";
// import Image from "next/image";
import Image from "@/components/ui/imageV2/ImageV2";
import { CLink } from "./customLink/CustomLink";
import { getCloudinaryURL } from "@/utils/cloudinary";
import { getCountryCodeFromLocale } from "@/apiUtils/commonUtils";
interface IFindStoreProps {
  findStoreSectionClass?: string;
  imgClass?: string;
  isCLP?: boolean;
  storeData?: FindStoreComponentData;
  locale: string;
}
const FindStore = ({
  findStoreSectionClass,
  imgClass,
  isCLP = false,
  storeData,
  locale,
}: IFindStoreProps) => {
  return (
    <div className={`flex-1 px-4 lg:relative lg:px-0 w-full`}>
      <Image
        // className={cn("hidden w-full sm:block object-cover", imgClass, isCLP ? "h-[504px]" : "h-[555px]")}
        className={cn("hidden w-full sm:block object-cover", imgClass)}
        style={{ aspectRatio: isCLP ? "8/3" : "2.42/1" }}
        src={
          storeData?.media?.largeMediaUrl
            ? (getCloudinaryURL(storeData?.media?.largeMediaUrl) ?? notFound)
            : notFound
        }
        width={1344}
        height={isCLP ? 504 : 555}
        alt={"store_image"}
      />
      <Image
        // className={cn("w-full sm:hidden object-cover", imgClass, isCLP ? "h-[431px]" : "h-[335px]")}
        className={cn("w-full sm:hidden object-cover", imgClass)}
        style={{ aspectRatio: isCLP ? "0.79/1" : "1/1" }}
        src={
          storeData?.media?.smallMediaUrl
            ? (getCloudinaryURL(storeData?.media?.smallMediaUrl) ?? notFound)
            : notFound
        }
        height={isCLP ? 431 : 335}
        width={isCLP ? 344 : 335}
        alt={"store_image"}
      />

      <div
        className={cn(
          `px-4 flex flex-col items-center gap-4 lg:absolute lg:left-1/2 lg:top-[90%] lg:h-[200px] lg:w-[420px] lg:-translate-x-1/2 lg:-translate-y-[90%] lg:transform lg:bg-white ${isCLP && "lg:top-1/2 lg:-translate-y-1/2"} flex flex-col justify-center pt-5`,
          findStoreSectionClass,
        )}
      >
        <p className="text-center text-sm text-tertiary-6">{storeData?.auxiliaryText}</p>
        <CLink href={storeData?.findStore?.link?.url ?? "/"} className="w-full max-w-[10.938rem]">
          <Button className="flex h-9 w-full items-center justify-center whitespace-nowrap px-10 text-sm font-semibold">
            {storeData?.findStore?.title}
          </Button>
        </CLink>
        {getCountryCodeFromLocale(locale) !== "sa" && (
          <CLink
            href={storeData?.bookEyeExam?.link?.url ?? "/"}
            className="text-sm font-semibold underline"
          >
            {storeData?.bookEyeExam?.title}
          </CLink>
        )}
      </div>
    </div>
  );
};

export default FindStore;
